
import wx from 'weixin-js-sdk'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import imgup from '@/assets/upload_img.png'
import icoLY from '@/assets/ico-ly.png'
import icoDel from '@/assets/ico-del.png'
import config from '@/config/index'
import { dealLetter, dealAppoint } from '@/api/youzheng.js'
import { getConfig, addFile } from '@/api/wx.js'
import Storage from '@/storage'
import store from '@/store'
export default {
name: 'myReply',
data () {
return {
imgup: imgup,
upimagelist: [],
imgcount: 5,
fileList: { fileUrlArr: [], fileIdArr: [] },
id: this.$route.params.id,
content: '',
accounttype: this.$store.state.user.personObj.accounttype,
isqyb: this.$store.state.user.personObj.isqyb,
index: 0,
baseUrl: config.baseUrl
}
},
components: {
XTextarea,
Group,
Flexbox,
FlexboxItem,
XButton
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
methods: {

wxconfig () {

let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if (
ua.match(/MicroMessenger/i) == 'micromessenger' &&
ua.match(/wxwork/i) == 'wxwork'
) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = this.$store.state.user.wechatSignUrl

}
getConfig({
url: href,
sicode: config.sicode
}).then(re => {
var configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: ['chooseImage', 'uploadImage', 'previewImage'] 
})
})
},

chooseFile (imglist, filelist, imgcount) {

wx.chooseImage({
count: this[imgcount], // 默认5
sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
success: (res) => {
var localIds = res.localIds
this.index = 0
if (localIds.length > 0) {
this[imgcount] = this[imgcount] - localIds.length
this.uploadFile(imglist, filelist, localIds)
}
}
})
},

uploadFile (imglist, filelist, localIds) {
if (this.index >= localIds.length) {
return
}
wx.uploadImage({
localId: localIds[this.index], // 需要上传的图片的本地ID，由chooseFile接口获得
success: res => {
addFile({
mediaId: res.serverId
}).then(re => {
imglist.push(re.returnValue)
filelist.fileUrlArr.push(config.baseUrl + re.returnValue.filepath)
filelist.fileIdArr.push(re.returnValue.id)
})
this.index++
this.uploadFile(imglist, filelist, localIds)
}
})
},

preview (index, filelist) {
wx.previewImage({
current: filelist.fileUrlArr[index], // 当前显示图片的http链接
urls: filelist.fileUrlArr 
})
},

imgclose (imglist, index, filelist, imgcount) {
const _this = this 
this.$vux.confirm.show({
title: '提示',
content: '您确定要删除这张图片么？',

onCancel () {
},
onConfirm () {
_this[imgcount] = _this[imgcount] + 1
imglist.splice(index, 1)
filelist.fileIdArr.splice(index, 1)
}
})
},

getsumbit () {
if (this.content != '') {
dealLetter({
accountid: this.accountid,
id: this.id,
dealmsg: this.content,
dealfileids: this.fileList.fileIdArr.length > 0 ? this.fileList.fileIdArr.join(';') : ''
}).then(res => {
this.$vux.toast.text('提交成功', 'middle')
this.$router.push({ name: 'myMailWorkDaiban', params: { selected: 2, tabIndex: 1 } })
})
} else {
this.$vux.toast.text('请填写回复内容', 'middle')
}
},

clean () {
this.content = ''
this.upimagelist = []
}
},
activated () {},
created () {
this.wxconfig()
}
}
